import React from "react";
import {sleep, StartActivity} from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {ActionListenerWorkRules} from "../../../../common/actionListener/actionListener";
import {CAT_WP_CONST} from "../../../../../constants/ActionEnums/CatActionEnums";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";
import {MAN_ME_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";


class PlaatsInDetailPlanning extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            begin: "",
            end: "",
            isSubmitDisabled: true
        };
        this.control1 = false;
        this.control2 = false;
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });
    };

    async handleChange(event) {
        var def, divId, nameId, pageNumber;
        let changeCount = 0;
        switch (event.target.id) {
            case "planningspatroon-zoeken-input":
                def = [process.env.REACT_APP_PLANNINGSPATRONEN];
                divId = "planningspatroon-grp";
                nameId = "planningspatroon";
                pageNumber = window.$mm_management_planningspatroonPageNUmber;
                changeCount++;
                break;
            case "planningsperiode-zoeken-input":
                def = [process.env.REACT_APP_PLANNINGSPERIODEN];
                divId = "planningsperiode-grp";
                nameId = "planningsperiode";
                pageNumber = window.$mm_management_planningsperiodePageNUmber;
                changeCount++
                break;
            default:
                break;
        }

        if (changeCount >= 2){
            this.setState({
                isSubmitDisabled:false
            })
        }
        var model = {
            content: [
                {
                    key: "algemeen-actief",
                    and_or: "AND",
                    values: [true],
                    datatype: "BOOLEAN",
                },
            ],
            definitions: def,
            text_search: [],
            sorting: [],
        };
        if (event.target.value) {
            model.text_search = [
                {
                    text_query: event.target.value,
                    search_fields: ["NAME", "IDENTIFIER", "IDENTIFICATION"],
                    fuzzy: true,
                    and_or: "OR",
                },
            ];
            model.sorting = [{sort_type: "text_score", direction: "DESCENDING"}];
        }
        let result = await omnimap.FillTableAction(
            model,
            1,
            window.$mm_management_units_token
        );
        CallBackFunctions.GrpCallBack(divId, nameId, result, 0);
    }

    handleSubmit = () => {
        $("#cover-spin").show(0);

        //Get checked boxes
        const _planningsPatroon = $("input[name=planningspatroon]:checked")[0];
        const _planningsPeriod = $("input[name=planningsperiode]:checked")[0];

        // const model = {
        //     planningsPatroon: _planningsPatroon
        //         .defaultValue,
        //     planningsPeriode:
        //         .defaultValue,
        // };

        // StartActivity(
        //     model,
        //     [window.$mm_measures_selectedIds],
        //     "ec5d1e75-6160-4f16-9c1c-fcaf6d271512",
        //     this.checkNumberOfWorkerRules,
        //     window.$mm_management_units_token
        // )


        const model = {
            "action": MAN_ME_CONST.PLACE_IN_GLOBAL_PLANNING,
            "planningspatroon_identification": _planningsPatroon.defaultValue,
            "planningsperiode_identification": _planningsPeriod.defaultValue,
            "identifications": window.$mm_measures_selectedIds
        }

        InitiateProcessAction(model, MAN_ME_CONST.END_POINT).then(()=>{
            this.checkNumberOfWorkerRules()

            // Clear checkbox
            _planningsPatroon.checked = false
            _planningsPeriod.checked = false

            //Close popup
            $("#plaats_in_globale_planning").modal("hide");

            this.setState({
                isSubmitDisabled: true
            });

        }).catch(()=>{
            alert('Something went wrong!')
            $("#cover-spin").hide(0);
        })
    };

    checkNumberOfWorkerRules = () => {
        $("#cover-spin").show(0);
        ActionListenerWorkRules(window.$mm_measures_selectedIds, ["cf229e93-cd9a-4b7c-b07f-55bb5d40f0e4", "ec5d1e75-6160-4f16-9c1c-fcaf6d271512"]);
        this.savedCallBack();
    }

    savedCallBack = () => {
        window.$mm_measures_refreshFunction();
        $("#cover-spin").hide(0);
    };

    handleSubmitButton = (control) => {
        if (control === 1 && $("input[name=planningspatroon]:checked")[0] !== undefined){
            this.control1 = true;
        }
        if (control === 2 && $("input[name=planningsperiode]:checked")[0] !== undefined){
            this.control2 = true;
        }
        if(this.control1 === true && this.control2 === true){
            this.setState({
                isSubmitDisabled: false
            })

            this.control1 = false;
            this.control2 = false;
        }
    }

    componentDidMount() {
        $("#plaats_in_globale_planning").on(
            "show.bs.modal",
            async function (event) {
                var model = {
                    content: [
                        {
                            key: "algemeen-actief",
                            and_or: "AND",
                            values: [true],
                            datatype: "BOOLEAN",
                        },
                    ],
                    definitions: [process.env.REACT_APP_PLANNINGSPATRONEN],
                };
                let planningspatroonResult = await omnimap
                    .FillTableAction(model, 1, window.$mm_management_units_token)
                    .catch((err) => {
                        alert(err);
                    });
                CallBackFunctions.GrpCallBack(
                    "planningspatroon-grp",
                    "planningspatroon",
                    planningspatroonResult,
                    1
                );

                var model = {
                    content: [
                        {
                            key: "algemeen-actief",
                            and_or: "AND",
                            values: [true],
                            datatype: "BOOLEAN",
                        },
                    ],
                    definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
                };
                let planningsperiodeResult = await omnimap
                    .FillTableAction(model, 1, window.$mm_management_units_token)
                    .catch((err) => {
                        alert(err);
                    });
                CallBackFunctions.GrpCallBack(
                    "planningsperiode-grp",
                    "planningsperiode",
                    planningsperiodeResult,
                    1
                );
            }
        );

        /***MODAL SCROLL END OF BOTTOM***/
        $("#planningspatroon-grp").scroll(async function () {
            var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_PLANNINGSPATRONEN],
            };
            var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (
                $("#planningspatroon-grp").prop("scrollHeight") -
                $("#planningspatroon-grp").scrollTop() <=
                $("#planningspatroon-grp").height() + buffer
            ) {
                let result = await omnimap.FillTableAction(
                    model,
                    window.$mm_management_planningspatroonPageNUmber++,
                    window.$mm_management_units_token
                );
                CallBackFunctions.GrpCallBack(
                    "planningspatroon-grp",
                    "planningspatroon",
                    result,
                    window.$mm_management_planningspatroonPageNUmber
                );
            }
        });
        /***MODAL SCROLL END OF BOTTOM***/
        $("#planningsperiode-grp").scroll(async function () {
            var model = {
                content: [
                    {
                        key: "algemeen-actief",
                        and_or: "AND",
                        values: [true],
                        datatype: "BOOLEAN",
                    },
                ],
                definitions: [process.env.REACT_APP_PLANNINGSPERIODEN],
            };
            var buffer = 2; // # of pixels from bottom of scroll to fire your function. Can be 0
            if (
                $("#planningsperiode-grp").prop("scrollHeight") -
                $("#planningsperiode-grp").scrollTop() <=
                $("#planningsperiode-grp").height() + buffer
            ) {
                let result = await omnimap.FillTableAction(
                    model,
                    window.$mm_management_planningsperiodePageNUmber++,
                    window.$mm_management_units_token
                );
                CallBackFunctions.GrpCallBack(
                    "planningsperiode-grp",
                    "planningsperiode",
                    result,
                    window.$mm_management_planningsperiodePageNUmber
                );
            }
        });
    }

    render() {
        return (

            <div>
                <div
                    className="modal fade"
                    tabIndex={-1}
                    role="dialog"
                    id="plaats_in_globale_planning"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div>
                                <div className="modal-header">
                                    <h5 className="modal-title">Plaats in Globale planning</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <div class="beheeractiviteit-zoeken-content">
                                        <p>Planningspatroon</p>

                                        <input
                                            id="planningspatroon-zoeken-input"
                                            type="search"
                                            className="modal-search"
                                            placeholder="Zoeken"
                                            autoComplete="off"
                                            onChange={this.handleChange}
                                        />
                                    </div>

                                    <div className="modal-scroll">
                                        <div id="planningspatroon-grp" className="radio-grp" onClick={()=>this.handleSubmitButton(1)}/>
                                    </div>

                                    <div class="btn-plannig-context">
                                        <br/>
                                        <h1>Planningsperiode:</h1>
                                        <p>Geselecteerd: Niets geselecteerd </p>
                                        <input
                                            id="planningsperiode-zoeken-input"
                                            type="search"
                                            className="modal-search"
                                            placeholder="Zoeken"
                                            onChange={this.handleChange}
                                        />
                                        <div className="modal-scroll">
                                            <div id="planningsperiode-grp" className="radio-grp" onClick={()=>this.handleSubmitButton(2)}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn-modal"
                                        onClick={this.handleSubmit}
                                        disabled={this.state.isSubmitDisabled}
                                    >
                                        Verwerken
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default PlaatsInDetailPlanning;
